import React from "react";
import { Button } from "reactstrap";

export default function ApplyAllWarnPopup({ close, type }) {
  return (
    <>
      {/* <div className="success_bg">
        <div className="success_content" style={{ maxWidth: "615px" }}>
          <img src="/assets/images/verify.svg" className="verify_img" alt="" />

          <div className="row">
            <div className="justify-content-center text-center">
              {type === "applyall" ? (
                <h2>Make sure you have apply changes in all canvas</h2>
              ) : (
                <h2>Image downloading in progress, please don't switch tabs</h2>
              )}
            </div>
          </div>
          <div className="row mt-3">
            <div className="justify-content-center text-center">
              <Button
                color="create_variations mb-3 ms-3"
                onClick={() => {
                  close();
                }}
              >
                Okay
              </Button>
            </div>
          </div>
        </div>
      </div> */}
      <div className="page-controller-tooltip">
        <div  onClick={close} className="page-controller-tooltip-close">
          <img src={"/assets/images/close-btn-tooltip.svg"} alt="Close" />
        </div>
        <div className="page-controller-tooltip-content">
          <h3>⚠️ Don’t Miss This Step!</h3>
          <p>
            To apply your current design to all jersey sizes, please click on
            the “Apply to All” button before proceeding.
          </p>
          <p>This ensures all your variations are generated correctly.</p>
        </div>
      </div>
    </>
  );
}
